import { ResizeObserver as Polyfill } from "@juggle/resize-observer";

if (!window.ResizeObserver) {
  window.ResizeObserver = Polyfill;
}
